<template>
  <v-card class="base-card shadow">
    <v-card-title class="headline accent--text pb-4"> Информация об издательстве </v-card-title>

    <v-card-text>
      <template v-if="!monography.isForeignPublishingHouse">
        <CardAutocompleteRow
          v-model="monography.publishingHouse"
          :items="publishingHouseList"
          item-value="id"
          item-text="name"
          label="Издательство"
          placeholder="Выберите издательство"
          :disabled="isShowMode"
          :no-filter="false"
          :error-messages="errorMessages.publishingHouse"
          :required="!isShowMode"
          @input="
            $v.monography.publishingHouse.$touch()
            updateState(), updateMonography()
          "
        />

        <CardAutocompleteRow
          v-model="monography.state"
          :items="stateList"
          item-value="id"
          item-text="name"
          label="Место издательства"
          placeholder="Выберите место издательства"
          :disabled="isShowMode"
          :error-messages="errorMessages.state"
          :required="!isShowMode"
          :no-filter="false"
          @input="
            $v.monography.state.$touch()
            updateMonography()
          "
        />
      </template>

      <template v-else>
        <CardFieldRow
          v-model="monography.foreignState"
          label="Издательство"
          placeholder="Добавьте издательство"
          :disabled="isShowMode"
          :error-messages="errorMessages.foreignState"
          :required="!isShowMode"
          @input="
            $v.monography.foreignState.$touch()
            updateMonography()
          "
        />

        <CardFieldRow
          v-model="monography.foreignPublishingHouseName"
          label="Место издательства"
          placeholder="Добавьте место издательства"
          :disabled="isShowMode"
          :error-messages="errorMessages.foreignPublishingHouseName"
          :required="!isShowMode"
          @input="
            $v.monography.foreignPublishingHouseName.$touch()
            updateMonography()
          "
        />
      </template>

      <CardRow>
        <v-checkbox
          class="rounded-lg mini-text field-edit d-inline-block"
          v-model="monography.isForeignPublishingHouse"
          label="Зарубежное издательство"
          hide-details
          dense
          :disabled="isShowMode"
          @change="
            clearState()
            updateMonography()
          "
        />
      </CardRow>

      <CardRadioRow
        v-model="monography.publicationForm"
        label="Форма издания"
        :disabled="isShowMode"
        :value-list="publicationFormList"
        :required="!isShowMode"
        hide-border-bottom
        @change="
          $v.monography.publicationForm.$touch()
          updateMonography()
        "
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { Monography } from '@/models'
import CardRow from '@/components/ui/row/CardRow'
import { requiredIf, required } from 'vuelidate/lib/validators'
import { setValidateMessages } from '../../../scripts/validation'
import CardAutocompleteRow from '../../ui/row/CardAutocompleteRow'
import CardFieldRow from '../../ui/row/CardFieldRow'
import { mapGetters } from 'vuex'
import CardRadioRow from '@/components/ui/row/CardRadioRow.vue'

export default {
  components: { CardRadioRow, CardFieldRow, CardAutocompleteRow, CardRow },
  props: {
    isShowMode: Boolean,
    selectedItem: Object
  },

  mounted() {
    this.updateInvalid()
  },

  data: () => ({
    monography: new Monography(),
    secondPublishingHouse: []
  }),

  validations() {
    return {
      monography: {
        publishingHouse: { required: requiredIf(() => !this.monography.isForeignPublishingHouse) },
        state: { required: requiredIf(() => !this.monography.isForeignPublishingHouse) },
        foreignState: { required: requiredIf(() => this.monography.isForeignPublishingHouse) },
        foreignPublishingHouseName: { required: requiredIf(() => this.monography.isForeignPublishingHouse) },
        publicationForm: { required }
      }
    }
  },

  computed: {
    ...mapGetters('dictionaries', ['publicationFormList', 'publishingHouseList', 'stateList']),

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.monography.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.monography[key])
      })

      return allErrors
    }
  },

  methods: {
    updateInvalid() {
      this.$emit('updateInvalid', this.$v.$invalid)
    },

    async updateMonography() {
      this.$emit('update:selected-item', this.monography)
      this.updateInvalid()
    },

    updateState() {
      this.monography.state = this.monography.publishingHouse?.place || null
    },

    clearState() {
      if (this.monography.isForeignPublishingHouse) {
        this.monography.state = null
        this.monography.publishingHouse = null
      } else {
        this.monography.foreignState = null
        this.monography.foreignPublishingHouseName = null
      }
    }
  },

  watch: {
    selectedItem: {
      immediate: true,
      deep: true,
      handler(val) {
        this.monography = new Monography(val.getForAPI())
        this.updateInvalid()
      }
    }
  }
}
</script>

<style scoped></style>
